const initFilter = {
  'value-chain': [],
  application: [],
  location: { place: null, range: 10 },
  partners: [],
  status: [],
};

export { initFilter };